import {
	SET_BILLING_COMPANY_DETAILS,
	SET_BILLING_COMPANY_DETAIL,
	SET_BILLING_COMPANY_DETAILS_META,
	SET_BILLING_SERIES_POLICIES,
	SET_BILLING_SERIES_POLICY,
	SET_BILLING_SERIES_POLICIES_META,
	SET_BILLING_DOCUMENT_CONFIGS,
	SET_BILLING_DOCUMENT_CONFIG,
	SET_BILLING_DOCUMENT_CONFIGS_META,
	SET_BILLING_DEBETAS_DIMENSION_DETAIL,
	SET_BILLING_DEBETAS_DIMENSION_DETAILS,
	SET_BILLING_DEBETAS_DIMENSION_HEADER,
	SET_BILLING_DEBETAS_DIMENSION_HEADERS,
	SET_BILLING_DEBETAS_DIMENSION_HEADER_DATA_FIELDS,
	SET_BILLING_RECORDS,
	SET_BILLING_RECORD,
	SET_BILLING_RECORD_RELATED_ORDER,
	SET_BILLING_RECORDS_META,
	SET_BILLING_CASH_REGISTERS,
	SET_BILLING_CASH_REGISTER,
	SET_BILLING_CASH_REGISTERS_META,
	SET_BILLING_CASH_REGISTER_SERIES_POLICIES,
	SET_BILLING_ACCOUNTING_EXPORT_CONFIG,
	SET_BILLING_DOCUMENT_ITEM_DESCRIPTIONS,
	SET_BILLING_DOCUMENT_ITEM_DESCRIPTIONS_META,
	SET_BILLING_DOCUMENT_ITEM_DESCRIPTION_GROUPS,
	SET_BILLING_DOCUMENT_ITEM_DESCRIPTION_GROUPS_META,
	SET_BILLING_DOCUMENT_ITEM_DESCRIPTION_GROUP,
	SET_SEARCH_FILTERS,
	SET_LOADING
} from './mutation-types'

export default {
	[SET_SEARCH_FILTERS] (state, searchFilters) {
		state.searchFilters = searchFilters
	},
	[SET_LOADING] (state, loading) {
		state.loading = { ...state.loading, ...loading }
	},
	[SET_BILLING_COMPANY_DETAILS] (state, billingCompanyDetails) {
		if (!billingCompanyDetails || !billingCompanyDetails.length) {
			state.billingCompanyDetailsMeta = {}
		}
		state.billingCompanyDetails = billingCompanyDetails
	},
	[SET_BILLING_COMPANY_DETAIL] (state, billingCompanyDetail) {
		state.billingCompanyDetail = billingCompanyDetail
	},
	[SET_BILLING_COMPANY_DETAILS_META] (state, meta) {
		state.billingCompanyDetailsMeta = meta
	},
	[SET_BILLING_SERIES_POLICIES] (state, billingSeriesPolicies) {
		if (!billingSeriesPolicies || !billingSeriesPolicies.length) {
			state.billingSeriesPoliciesMeta = {}
		}
		state.billingSeriesPolicies = billingSeriesPolicies
	},
	[SET_BILLING_SERIES_POLICY] (state, billingSeriesPolicy) {
		state.billingSeriesPolicy = billingSeriesPolicy
	},
	[SET_BILLING_SERIES_POLICIES_META] (state, meta) {
		state.billingSeriesPoliciesMeta = meta
	},
	[SET_BILLING_DOCUMENT_CONFIGS] (state, billingDocumentConfigs) {
		if (!billingDocumentConfigs || !billingDocumentConfigs.length) {
			state.billingDocumentConfigsMeta = {}
		}
		state.billingDocumentConfigs = billingDocumentConfigs
	},
	[SET_BILLING_DOCUMENT_CONFIG] (state, billingDocumentConfig) {
		state.billingDocumentConfig = billingDocumentConfig
	},
	[SET_BILLING_DOCUMENT_CONFIGS_META] (state, meta) {
		state.billingDocumentConfigsMeta = meta
	},
	[SET_BILLING_DEBETAS_DIMENSION_DETAIL] (state, billingDebetasDimensionDetail) {
		state.billingDebetasDimensionDetail = billingDebetasDimensionDetail
	},
	[SET_BILLING_DEBETAS_DIMENSION_DETAILS] (state, billingDebetasDimensionDetails) {
		state.billingDebetasDimensionDetails = billingDebetasDimensionDetails
	},
	[SET_BILLING_DEBETAS_DIMENSION_HEADER] (state, billingDebetasDimensionHeader) {
		state.billingDebetasDimensionHeader = billingDebetasDimensionHeader
	},
	[SET_BILLING_DEBETAS_DIMENSION_HEADERS] (state, billingDebetasDimensionHeaders) {
		state.billingDebetasDimensionHeaders = billingDebetasDimensionHeaders
	},
	[SET_BILLING_DEBETAS_DIMENSION_HEADER_DATA_FIELDS] (state, billingDebetasDimensionHeaderDataFields) {
		state.billingDebetasDimensionHeaderDataFields = billingDebetasDimensionHeaderDataFields
	},
	[SET_BILLING_RECORDS] (state, billingRecords) {
		if (!billingRecords || !billingRecords.length) {
			state.billingRecordsMeta = {}
		}
		state.billingRecords = billingRecords
	},
	[SET_BILLING_RECORD] (state, billingRecord) {
		state.billingRecord = billingRecord
	},
	[SET_BILLING_RECORD_RELATED_ORDER] (state, billingRecordRelatedOrder) {
		state.billingRecordRelatedOrder = billingRecordRelatedOrder
	},
	[SET_BILLING_RECORDS_META] (state, meta) {
		state.billingRecordsMeta = meta
	},
	[SET_BILLING_CASH_REGISTERS] (state, billingCashRegisters) {
		if (!billingCashRegisters || !billingCashRegisters.length) {
			state.billingCashRegistersMeta = {}
		}
		state.billingCashRegisters = billingCashRegisters
	},
	[SET_BILLING_CASH_REGISTER] (state, billingCashRegister) {
		state.billingCashRegister = billingCashRegister
	},
	[SET_BILLING_CASH_REGISTERS_META] (state, meta) {
		state.billingCashRegistersMeta = meta
	},
	[SET_BILLING_CASH_REGISTER_SERIES_POLICIES] (state, billingSeriesPolicies) {
		state.billingCashRegisterSeriesPolicies = billingSeriesPolicies
	},
	[SET_BILLING_ACCOUNTING_EXPORT_CONFIG] (state, billingAccountingExportConfig) {
		state.billingAccountingExportConfig = billingAccountingExportConfig
	},
	[SET_BILLING_DOCUMENT_ITEM_DESCRIPTIONS] (state, billingDocumentItemDescriptions) {
		if (!billingDocumentItemDescriptions || !billingDocumentItemDescriptions.length) {
			state.billingDocumentItemDescriptionsMeta = {}
		}
		state.billingDocumentItemDescriptions = billingDocumentItemDescriptions
	},
	[SET_BILLING_DOCUMENT_ITEM_DESCRIPTIONS_META] (state, meta) {
		state.billingDocumentItemDescriptionsMeta = meta
	},
	[SET_BILLING_DOCUMENT_ITEM_DESCRIPTION_GROUPS] (state, billingDocumentItemDescriptionGroups) {
		if (!billingDocumentItemDescriptionGroups || !billingDocumentItemDescriptionGroups.length) {
			state.billingDocumentItemDescriptionGroupsMeta = {}
		}
		state.billingDocumentItemDescriptionGroups = billingDocumentItemDescriptionGroups
	},
	[SET_BILLING_DOCUMENT_ITEM_DESCRIPTION_GROUPS_META] (state, meta) {
		state.billingDocumentItemDescriptionGroupsMeta = meta
	},
	[SET_BILLING_DOCUMENT_ITEM_DESCRIPTION_GROUP] (state, billingDocumentItemDescriptionGroup) {
		state.billingDocumentItemDescriptionGroup = billingDocumentItemDescriptionGroup
	}
}
